import { Bell } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { useNotificationPreferences, useUpdateNotificationPreferences } from "@/hooks/useNotificationSettings";
import { Skeleton } from "@/components/ui/skeleton";

export function NotificationsTab() {
  const { data: preferences, isLoading } = useNotificationPreferences();
  const updatePreferences = useUpdateNotificationPreferences();

  const prefs = (preferences as any) || {};

  const handleToggle = (category: string, key: string, value: boolean) => {
    const updated = {
      ...prefs,
      [category]: {
        ...(prefs[category] || {}),
        [key]: value,
      },
    };
    updatePreferences.mutate(updated);
  };

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-64" />
        </CardHeader>
        <CardContent>
          <Skeleton className="h-48 w-full" />
        </CardContent>
      </Card>
    );
  }

  const emailPrefs = prefs.email || {};

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Bell className="h-5 w-5" />
            Email Notifications
          </CardTitle>
          <CardDescription>
            Choose which notifications you want to receive via email
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="space-y-4">
            <h3 className="font-medium">System</h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <Label htmlFor="weekly-summary" className="cursor-pointer">
                  Weekly summary email
                </Label>
                <Switch
                  id="weekly-summary"
                  checked={emailPrefs.weekly_summary || false}
                  onCheckedChange={(checked) =>
                    handleToggle("email", "weekly_summary", checked)
                  }
                />
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
